import Image from "next/legacy/image";
const steps = [
    {name: 'Step 1', icon: '/assets/images/club-member/steps/1.svg', description: 'Sign Up', extra_description: null},
    {name: 'Step 2', icon: '/assets/images/club-member/steps/2.svg', description: 'Download the digital ID', extra_description: null},
    {name: 'Step 3', icon: '/assets/images/club-member/steps/3.svg', description: 'Scan and Earn Points', extra_description: '₱40 = 1 Point'},
];

export default function HowItWorks(){
    return(
        <section id="howitworks" className='lg:scroll-mt-[150px] md:scroll-mt-[140px] sm:scroll-mt-[130px] scroll-mt-[80px] snap-normal snap-start w-full bg-rapide-yellow md:pt-12 pt-4 border-t border-gray-200'>
            <div className='max-w-screen-xl mx-auto md:px-12 px-4'>
                <h1 className='text-5xl text-center'>Earn and Pay with Points in just 3 EASY STEPS!</h1>
                <div className='grid md:grid-cols-3 grid-cols-1 gap-4 py-8'>
                    {steps.map((step, index) => {
                        return(
                            <div key={index} className='flex flex-col relative'>
                                <div className='relative lg:w-60 lg:h-60 md:w-40 md:h-40 w-24 h-24 mx-auto'>
                                    <Image
                                        alt={step.name}
                                        src={step.icon}
                                        layout="responsive"
                                        height={1000}
                                        width={1000}
                                        objectFit="contain"
                                    />
                                </div>
                                <div className='text-center'>
                                    <h1 className='text-xl font-bold'>{step.name}</h1>
                                    <p className='font-semibold text-lg'>{step.description}</p>
                                    {step.extra_description && (
                                        <p className='text-base'>{step.extra_description}</p>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}